module.exports = __webpack_public_path__ + "img/63.44ac829c.png";